module.exports = __webpack_public_path__ + "static/img/far1_active.47bf0dfb.png";